import { ApiRequest } from "../../../../state/api/ApiRequest";

export async function registerContact(userId: string, careRecipientId: string, email: string, name: string, label: string ,tel1: string ,tel2: string): Promise<void> {
    const body = {
        email: email,
        name: name,
        label: label,
        tel1: tel1,
        tel2: tel2,
    };
    return await ApiRequest.post(
        `/api/contact/${userId}/${careRecipientId}`,
        {},
        body,
        () => {},
        () => {}
    );
}

export async function deleteContact(id: string): Promise<void> {
    const url = `/api/contact/${id}`;
    return await ApiRequest.delete(
        url, {}, () => {}, () => {}
    );
}

export async function getContacts(userId: string, careRecipientId: string): Promise<Contact[]> {
    const url = `/api/contact/${userId}/${careRecipientId}`;
    const data = await ApiRequest.get(url, {}, () => {}, () => {});
    return data;
}

export type Contact = {
    id: string,
    name: string,
    email: string,
    label: string,
    tel1: string,
    tel2: string,
    verified: boolean,
    verifiedAt: string,
}

